import { useEffect, useState } from "react";
import getTokensMetadata from "@services/Metadata/getTokensMetadata";
import { SPACE_STATIONS_SLUG } from "@constants/env";
import { ITokenItem } from "@interfaces/Hangar/TokenItem";
import TemplateBox from "../TemplateBox";
import Link from "@components/Link";
import { getLinkCollection } from "@scripts/CollectionHelper";
import { APARTMENT_DETAIL } from "@routes/routes";
import { EHangarTitleType } from "@customTypes/MyHangar/HangarTitleType";

interface IPlanetsParams {
    items: ITokenItem[];
}

const SpaceStations = ({ items }: IPlanetsParams): JSX.Element => {
    const [spaceStationsMetadata, setSpaceStationsMetadata] = useState<
        { tokenId: string; name: string; image: string }[]
    >([]);

    useEffect(() => {
        if (items.length === 0) {
            return;
        }

        const tokenIds = items.map(({ id }) => id.toString());

        getTokensMetadata(SPACE_STATIONS_SLUG, tokenIds).then(({ data: planets }) => {
            const spaceStationsMetadata: { tokenId: string; name: string; image: string }[] = [];
            for (const {
                metadata: { name, image },
                config: { tokenId },
            } of planets) {
                spaceStationsMetadata.push({ tokenId, name, image });
            }

            setSpaceStationsMetadata(spaceStationsMetadata);
        });
    }, []);

    return items.length > 0 ? (
        <TemplateBox title={EHangarTitleType.APARTMENTS}>
            {spaceStationsMetadata.map(({ tokenId, image, name }) => (
                <Link to={getLinkCollection(APARTMENT_DETAIL, tokenId.toString(), name)} key={tokenId}>
                    <img src={image} alt={name} />
                    <span>{name}</span>
                </Link>
            ))}
        </TemplateBox>
    ) : (
        <></>
    );
};

export default SpaceStations;
